import request from '@/utils/request'

// 管理员列表
export function operatorList(params) {
  return request.get('/webapi/admin/adminList', { params })
}

// 编辑管理员
export function editOperator(data) {
  return request.post('/webapi/admin/adminEdit', data)
}

// 添加管理员
export function addOperator(data) {
  return request.post('/webapi/admin/adminAdd', data)
}

// 启/禁用管理员状态
export function operatorStatus(data) {
  return request.post('/webapi/admin/adminStatus', data)
}

// 删除管理员
export const adminDel = (data) => {
  return request.post('/webapi/admin/adminDel', data)
}

// 客户详情 (用工方获取详情接口不需要传递id直接通过token获取)
export function customerDetail() {
  return request({ url: '/webapi/company/companyDetail', method: 'get' })
}

// 客户详情编辑
export function companyEdit(data) {
  return request({ url: '/webapi/company/companyEdit', method: 'post', data })
}

// 客户详情审核更新
export function updateCompany(data) {
  return request({ url: '/webapi/company/updateCompany', method: 'post', data })
}

// 角色列表
export function roleList(data) {
  return request({ url: '/webapi/auth/roleList', method: 'post', data })
}

// 添加角色
export function roleAdd(data) {
  return request({ url: '/webapi/auth/roleAdd', method: 'post', data })
}

// 编辑角色
export function roleEdit(data) {
  return request({ url: '/webapi/auth/roleEdit', method: 'post', data })
}

// 设置角色权限
export function setroleNode(data) {
  return request({ url: '/webapi/auth/setroleNode', method: 'post', data })
}

// 禁用启用角色
export function roleStatus(data) {
  return request({ url: '/webapi/auth/roleStatus', method: 'post', data })
}

// 删除角色
export function roleDel(data) {
  return request({ url: '/webapi/auth/roleDel', method: 'post', data })
}

// 权限列表
export function nodeList() {
  return request({ url: '/webapi/auth/nodeList', method: 'post' })
}

// 角色包含权限
export function roleAuth(data) {
  return request({ url: '/webapi/auth/roleAuth', method: 'post', data })
}

// TODO 文件流请求模板 后面可能需要，暂时不删除
// 下载合同
export function downloadContract(params) {
  return request({ url: '/taxapi/tax/signShow', method: 'get', params: params.data, responseType: params.responseType })
}

// 下载身份证
export function downloadPic(params) {
  return request({ url: '/taxapi/tax/downloadPic', method: 'get', params: params.data, responseType: params.responseType })
}

// 创客列表/个税报表/增值及附加税报表
export function reportForms({ url, params, responseType }) {
  return request({ url, method: 'get', params, responseType })
}

// 签约主体
export function channelList() {
  return request({ url: '/webapi/capital/channelList', method: 'post' })
}

// 获取公司服务费率配置
export function rateConfigList() {
  return request({ url: '/webapi/company/rateConfig', method: 'get' })
}

// 创建e签宝签署授权
export function applyEsignAuth(data) {
  return request({ url: '/webapi/esign/applyEsignAuth', method: 'post', data })
}

// 取消e签宝授权
export function cancelEsignAuth() {
  return request({ url: '/webapi/esign/cancelEsignAuth', method: 'post' })
}

